<template>
    <div class="chart-wrap" ref="container-chart">
        <highcharts :options="options" ref="pieIdChart" ></highcharts>
        <div class="center-absolute" style="height: auto!important">
            <slot />
        </div>
    </div>
</template>

<script>

    export default {
        props:['data'],
        data:function(){
            return{
                options:{
                    chart: {
                        type: 'pie',
                        margin:[0,0,0,0],
                        spacingBottom:0,
                        spacingRight:0,
                        spacingLeft:0,
                        spacingtop:0,
                        backgroundColor:'rgba(0,0,0,0)'
                    },
                    credits:{
                        enabled:false
                    },
                    legend: {
                        enabled:false,
                    },
                    title: {
                        text: ''
                    },
                    tooltip: {
                         enabled:false,
                        // headerFormat: '<b>{point.x}</b><br/>',
                        //pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: false,
                                distance: 0,
                                style: {
                                    fontWeight: 'bold',
                                    color: 'white'
                                }
                            },
                           // center: ['50%', '50%'],
                            //showInLegend: true
                            //colors: (this.colors) ? this.colors : [],
                            //size: '110%'
                        }
                    },
                    colors:['rgb(74, 241, 177)','rgba(0, 0, 0, 0.33)'],
                    series: [
                        {
                            name: '',
                            data: [],
                            innerSize: '80%',
                            outerSize: '110%',
                            borderWidth:0,
                        }
                    ]

                }
            }
        },
        mounted() {
            this.setSeries(this.data)
        },
        watch:{
            data(n,o){
                this.setSeries(n)
            }
        },
        methods:{
            setSeries(n){
                var chart = this.$refs['pieIdChart'].chart;
                chart.series[0].setData([n,100-n]);
                
            }
        }
    }
</script>
<style>
    .chart-wrap{
        margin: auto;
        height: 100% !important;
        width: 100% !important;
        position: relative;
    }
    .chart-wrap .highcharts-container{
        height: 100% !important;
        width: 100% !important;
    }

    .chart-wrap>div{
        height: 100% !important;
        width: 100% !important;                
    }
    .center-absolute{
        position: absolute;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        top:50%;
        transform: translateY(-50%);
    }
    .chart-wrap>div svg{
        height: 100% !important;
        width: 100% !important;
    }
</style>
